import React, { Component } from 'react';
import Link from 'react-router-dom/Link';
import fecha from 'fecha';

import { timeframeToLocalizedString, kindToLocalizedString } from "../../Events/helpers";


import {observer} from 'mobx-react'
import store from '../Store';
import uiState, {StatusConstants} from "../../../core/uiState";

import styles from './Index.sass';

@observer
export default class ItemListPage extends Component {

    state = {
        items: []
    };

    async componentWillMount() {
        if (store.isPopulated) {
            return
        }

        uiState.setStatus(StatusConstants.RENDERING);
        await store.populate();
        uiState.setStatus(StatusConstants.READY)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    static getMonthDiff(a, b) {
        let m = (b.getFullYear() - a.getFullYear()) * 12;

        m -= a.getMonth() + 1;
        m += b.getMonth();

        return m > 0 ? m : 0;
    }

    renderItems() {
        const now = Date.now();
        let upcoming = false;

        let curDateStart;
        let curYear;
        let curMonth;
        let curDay;

        let lastDateStart;
        let lastYear;
        let lastMonth;
        let lastDay;

        let yearChanged = false;
        let monthChanged = false;

        const elements = [];

        for (let i = 0; i < store.events.length; i++) {
            const event = store.events[i];

            curDateStart = new Date(event.timeframe.start);
            curYear = curDateStart.getFullYear();
            curMonth = curDateStart.getMonth();
            curDay = curDateStart.getDate();

            yearChanged = false;
            monthChanged = false;

            if (lastDateStart === undefined) {
                lastDateStart = curDateStart
            }

            if (event.timeframe.end !== undefined) {
                upcoming = now < new Date(event.timeframe.end)
            } else {
                upcoming = now < curDateStart
            }

            if (curYear !== lastYear) {
                elements.push(renderYear(i, curYear));
                lastYear = curYear;

                yearChanged = true
            }

            if (yearChanged || curMonth !== lastMonth) {
                elements.push(renderMonth(i, curDateStart, !yearChanged && ItemListPage.getMonthDiff(curDateStart, lastDateStart)));
                lastMonth = curMonth;

                monthChanged = true
            }

            if (monthChanged || curDay !== lastDay) {
                elements.push(renderDay(i, fecha.format(curDateStart, 'DD'), upcoming));
                lastDay = curDay;
            }

            lastDateStart = curDateStart;

            elements.push(renderItem(i, event, upcoming))
        }

        elements.push(<span key="year-prehistory" className="year prehistory">Prekambr</span>);

        return elements
    }

    render() {
        return [
            <div key="content" className={styles.root}>
                {store.events.length > 0 &&
                    <div className={styles.timeline}>
                        {this.renderItems()}
                    </div>
                }
            </div>
        ]
    }
}

const renderYear = (i, year) =>
    <span key={'year-' + i} className="year">
        {year}
    </span>;

const renderMonth = (i, curDateStart, isBreak) =>
    <span key={'month-' + i} className={`month${isBreak ? ' break' : ''}`}>
        {fecha.format(curDateStart, 'MMMM')}
    </span>;

const renderDay = (i, day, upcoming) =>
    <span key={'day-' + i} className={'day' + (upcoming ? ' upcoming' : '')}>
        <span>{day}</span>
    </span>;

const renderItem = (i, event, upcoming) =>
    <Link key={'item-' + i} to={`/wydarzenia/${event.slug}`} className={styles.event + (upcoming ? ' upcoming' : '')}>
        <span>{kindToLocalizedString(event.kind)}</span>
        <div>
            <h3>{event.title}</h3>
            <span dangerouslySetInnerHTML={{ __html: timeframeToLocalizedString(event.timeframe) }} />
        </div>
    </Link>;



// WEBPACK FOOTER //
// ./src/modules/Events/pages/Index.js